import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "level" }
const _hoisted_2 = { class: "level-left" }
const _hoisted_3 = { class: "level-item" }
const _hoisted_4 = {
  key: 0,
  class: "level-item"
}
const _hoisted_5 = { class: "flow-selector__main" }
const _hoisted_6 = { class: "flow-selector__list" }
const _hoisted_7 = { class: "icon draggable" }
const _hoisted_8 = ["for"]
const _hoisted_9 = ["for"]

import Draggable from 'vuedraggable';
import DragIcon from '@/shared/components/DragIcon.vue';
import { FlowSelectorItemViewModel } from '../../models/flowSelectorItemViewModel';
import appInsights from '@/shared/services/appInsights';
import TitledSection from '@/shared/components/TitledSection.vue';
import Icon from '@/shared/icons/Icon.vue';
import { computed, PropType, ref } from 'vue';
import { useVModel } from '@vueuse/core';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'FlowSelector',
  props: {
  modelValue: {
    type: Array as PropType<FlowSelectorItemViewModel[]>,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    required: true,
  },
  icon: {
    type: String as PropType<'FlowIcon' | 'AnswerIcon'>,
    required: true,
  },
  tooltip: {
    type: String,
    default: '',
  },
  reorderable: {
    type: Boolean,
    default: true,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;
const flows = useVModel(props, 'modelValue', emit);

const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);

function handleFlowSelectedChange() {
  appInsights.trackEvent({ name: 'Bot Preview: Flow selected changed' }, { workspaceId: currentWorkspace.value.id });
  setPriorities();
}

function updatePriorities() {
  appInsights.trackEvent({ name: 'Bot Preview: Flow priorities changed' }, { workspaceId: currentWorkspace.value.id });
  setPriorities();
}

function setPriorities() {
  let selectedFlowCount = flows.value.filter((x) => x.isSelected).length;
  flows.value.forEach((flow) => {
    flow.priority = flow.isSelected ? selectedFlowCount-- : 0;
  });
}

return (_ctx: any,_cache: any) => {
  const _component_n_tooltip = _resolveComponent("n-tooltip")!
  const _component_n_toggle = _resolveComponent("n-toggle")!

  return (_openBlock(), _createBlock(TitledSection, {
    class: "flow-selector",
    "align-content-left": true
  }, {
    icon: _withCtx(() => [
      _createVNode(Icon, {
        icon: __props.icon,
        class: "icon"
      }, null, 8, ["icon"])
    ]),
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.title), 1)
    ]),
    subtitle: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(__props.subtitle), 1),
          (__props.tooltip)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_n_tooltip, {
                  text: __props.tooltip,
                  position: "top"
                }, null, 8, ["text"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (__props.reorderable)
            ? (_openBlock(), _createBlock(_unref(Draggable), {
                key: 0,
                modelValue: _unref(flows),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(flows) ? (flows).value = $event : null)),
                onEnd: updatePriorities,
                "item-key": "id"
              }, {
                item: _withCtx(({ element: flow }) => [
                  (_openBlock(), _createElementBlock("div", {
                    class: "flow-selector__list-item",
                    key: flow.id
                  }, [
                    _createElementVNode("span", _hoisted_7, [
                      _createVNode(DragIcon, {
                        color: "#A9A9A9",
                        class: "draggable"
                      })
                    ]),
                    _createElementVNode("label", {
                      for: `toggle-${flow.id}`,
                      class: "flow-selector__toggle-label"
                    }, _toDisplayString(flow.name), 9, _hoisted_8),
                    _createVNode(_component_n_toggle, {
                      modelValue: flow.isSelected,
                      "onUpdate:modelValue": ($event: any) => ((flow.isSelected) = $event),
                      label: flow.name,
                      hideLabel: true,
                      id: `toggle-${flow.id}`,
                      onInput: handleFlowSelectedChange
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "id"])
                  ]))
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(flows), (flow) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flow-selector__list-item",
                  key: flow.id
                }, [
                  _createElementVNode("label", {
                    for: `toggle-${flow.id}`,
                    class: "flow-selector__toggle-label"
                  }, _toDisplayString(flow.name), 9, _hoisted_9),
                  _createVNode(_component_n_toggle, {
                    label: flow.name,
                    modelValue: flow.isSelected,
                    "onUpdate:modelValue": ($event: any) => ((flow.isSelected) = $event),
                    onInput: handleFlowSelectedChange,
                    hideLabel: true,
                    id: `toggle-${flow.id}`
                  }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "id"])
                ]))
              }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})